import { AfterViewInit, Component, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { TreeSelectorComponent , TreeSelectorComponent as TreeSelectorComponent_1 } from "~app/common/components/tree-selector/tree-selector.component";
import { GridBaseComponent } from "../grid-base/grid-base.component";

@Component({
    selector: "rask-grid-tree-seletor-editor",
    templateUrl: "./grid-tree-seletor-editor.component.html",
    styleUrls: ["./grid-tree-seletor-editor.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TreeSelectorComponent_1]
})
export class GridTreeSeletorEditorComponent extends GridBaseComponent implements AfterViewInit {
    @ViewChild(TreeSelectorComponent) instance: TreeSelectorComponent;

    isPopup(): boolean {
        return true;
    }

    getValue(): any {
        return this.values;
    }

    onTreeSelectionEvent($event: any): void {
        this.valueChangedCallback(this.values);
    }

    ngAfterViewInit() {
        setTimeout(() => {
            this.instance.show = true;
        }, 10);
    }
}
